import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Modals.css";
const ConfirmationModal = ({
  show,
  handleClose,
  handleConfirm,
  title,
  children,
  isSubmitting,
  buttonTitle,
  LinkTitle,
  LinkTitle2
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <Modal.Header className="d-flex justify-content-end">
        <Modal.Title></Modal.Title>
          <img src="/close.png" alt="Close" className="custom-close-button" onClick={handleClose} />
      </Modal.Header>

      <Modal.Body>
        <span className="modal-title">
          <h5 className="mb-4">{title}</h5>
        </span>
        <span className="modal-contentx">{children}</span>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="primary-button"
          onClick={handleConfirm}
          disabled={isSubmitting}
        >
          {isSubmitting ? "Envoi..." : buttonTitle}
        </button>
        <Link to="/" >{LinkTitle}</Link>
        <Link onClick={handleClose} >{LinkTitle2}</Link>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmationModal;
